import { render, staticRenderFns } from "./vista_aprobar_gestion.vue?vue&type=template&id=841a6b9a"
import script from "./vista_aprobar_gestion.vue?vue&type=script&lang=js"
export * from "./vista_aprobar_gestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports